<template>
  <v-footer dark absolute app class="footer" color="#003A70" height="174">
    <div class="footer__top text-left">
      <div class="footer-logo">
        <router-link to="/" class="footer-logo__prepend"></router-link>
        <div class="footer__separator"></div>
        <router-link to="/" class="footer-logo__append"></router-link>
      </div>
      <div class="footer__gift-btn-wrapper">
        <v-btn
          class="gift-btn"
          color="primary"
          href="https://tour.givesmart.com"
          target="_blank"
        >
          <v-icon>$gift</v-icon>
          <span>
            Donate
          </span>
        </v-btn>
      </div>
      <div class="footer-actions text-right">
        <div style="max-width: 350px;float: right;">
          <div class="footer-actions__cta">
            Share your email for PGA TOUR Championship updates
          </div>
          <v-btn
            @click="subscribeModal = true"
            class="subscribe-btn"
            dark
            block
            outlined
          >
            <span>Email address</span>
            <v-icon>$arrow_right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <div class="text-left">©2020 PGA TOUR</div>
      <div class="text-center">
        <v-btn icon target="_blank" href="https://www.facebook.com/PGATour">
          <v-icon>$facebook</v-icon>
        </v-btn>
        <v-btn icon target="_blank" href="https://twitter.com/pgatour">
          <v-icon>$twitter</v-icon>
        </v-btn>
        <v-btn icon target="_blank" href="https://www.instagram.com/pgatour">
          <v-icon>$instagram</v-icon>
        </v-btn>
        <v-btn
          icon
          target="_blank"
          href="https://www.linkedin.com/company/pga-tour/"
        >
          <v-icon>$linkedin</v-icon>
        </v-btn>
      </div>
      <div class="text-right">
        <router-link to="/support">
          Contact us
        </router-link>
      </div>
    </div>
    <!--<EmailSubscribeModal v-model="subscribeModal" />-->
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      subscribeModal: false,
    };
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    if (!localStorage.subscribeModalSeen) {
      this.subscribeModal = true;
      localStorage.subscribeModalSeen = true;
    }
  },
};
</script>

<style scoped lang="scss">
.footer {
  display: block;
  font-family: "Roboto Condensed";

  &__gift-btn-wrapper {
    text-align: center;
  }
  &__top {
    border-bottom: 1px solid #676767;
    margin-bottom: 10px;
    height: 110px;
  }
  &__top > *,
  &__bottom > * {
    width: 100%;
  }
  &__bottom a {
    color: white;
    text-decoration: none !important;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;

    &:hover {
      text-decoration: underline;
    }
  }
  &__top,
  &__bottom {
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
  }

  &-logo {
    display: flex;

    &__prepend {
      display: block;
      width: 117px;
      height: 50px;
      background-image: url("~@/assets/logo.png");
      background-size: contain;
      background-position: center center;
      transition: 0.3s;
    }

    &__append {
      background-image: url("~@/assets/logo-append.svg");
      background-position: center center;
      background-size: contain;
      width: 135px;
      height: 45px;
    }
  }

  &__separator {
    width: 1px;
    height: 50px;
    background: #b1b3b3;
    margin: 0 20px;
  }

  &-actions {
    margin: 15px 0;
    font-weight: normal;
    font-size: 14px;
    &__cta {
      font-weight: 700;
    }
  }
}
.text-left {
  font-weight: 700;
}

.footer__bottom .text-right a {
  font-size: 20px;
}

.subscribe-btn {
  justify-content: space-between;
  margin-top: 5px;
}
@media screen and (max-width: 800px) {
  .footer-actions {
    display: none;
  }
  .footer__top > *,
  .footer__bottom > * {
    text-align: center !important;
    margin: 2px 0;
  }
  .footer__top {
    border-bottom: none;
    height: unset;
  }
  .footer__bottom {
    flex-direction: column-reverse;
    align-items: flex-end;
  }
  .footer {
    height: unset;
    padding: 20px 20px 17px 20px;

    &__gift-btn-wrapper {
      text-align: right !important;
    }
  }
  .footer-logo__prepend {
    width: 84px;
  }
  .footer-logo__append {
    width: 68px;
  }
  .footer__separator {
    height: 32px;
    margin: 0 10px;
  }
  .footer-logo {
    align-items: center;
  }
}
</style>
